import React, { useContext } from "react";
import "./Profile.css";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/IDS";

export default function Profile() {
  const { userdata } = useContext(Context);

  return (
    <section className="nav-profile-section">
      <div className="first-border">
        {/* <div className="profile-image">
          {userdata?.profile_photo ? (
            <img
              src={`${IDS.IMG_URL}${encodeURI(userdata?.profile_photo)}`}
              alt="Profile"
            />
          ) : (
            "PP"
          )}
        </div> */}

        <div className="profile-image">
          {userdata?.profile_photo ? (
            <img
              src={`${IDS.IMG_URL}${encodeURI(userdata?.profile_photo)}`}
              alt="Profile"
            />
          ) : userdata?.name ? (
            userdata.name
              .split(" ")
              .map((word) => word[0])
              .join("")
              .toUpperCase()
              .slice(0, 2)
          ) : (
            ""
          )}
        </div>
      </div>
    </section>
  );
}
